import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useMemo } from 'react';
import { LOCATION_SCOPED_STEPS } from '../constants';
import { OrgConfigWizardContext } from '../context';
import { useLocationsAPI } from '../selectors';
export var LocationStepLayout = function (_a) {
    var _b;
    var children = _a.children;
    var _c = useContext(OrgConfigWizardContext), step = _c.step, configVersionId = _c.configVersionId, selectedLocationId = _c.selectedLocationId, setSelectedLocationId = _c.setSelectedLocationId;
    var _d = useLocationsAPI(configVersionId), locationsData = _d[0], fetchLocations = _d[1];
    var locations = useMemo(function () { var _a, _b; return (_b = (_a = locationsData.data) === null || _a === void 0 ? void 0 : _a.locations) !== null && _b !== void 0 ? _b : []; }, [(_b = locationsData.data) === null || _b === void 0 ? void 0 : _b.locations]);
    var needsLocationContext = LOCATION_SCOPED_STEPS.includes(step);
    useEffect(function () {
        if (configVersionId && needsLocationContext) {
            fetchLocations();
        }
    }, [configVersionId, needsLocationContext, fetchLocations]);
    useEffect(function () {
        if (needsLocationContext && locations.length > 0 && selectedLocationId === null) {
            setSelectedLocationId(locations[0].id);
        }
    }, [needsLocationContext, locations, selectedLocationId, setSelectedLocationId]);
    return _jsx(_Fragment, { children: children });
};
